import { NegotiationRoundStatus, type PortalNegotiationRoundDto } from "../../../../autogen/bff-api";

export const roundAcceptsBids = (round: PortalNegotiationRoundDto, now: number = Date.now()): boolean =>
  round.status === NegotiationRoundStatus.Published && Date.parse(round.deadline) > now;
